export default "__VITE_ASSET__50a28cff__"